import { useClient } from '@composables/use-clients';
import { urls } from '@api/urls';
import { PostRequestArgsType } from '@api/v1/types';
import { withTryCatch } from '@api/v1/error-handlers';

export type NewUserSerializer = {
  firstName: string;
  lastName: string;
  email: string;
  headline: string;
  location: string;
  password: string;
  invitationCode: string;
  verificationCode: string;
  ssoCode: string;
  access: string;
  accessExpiresIn: number;
  refresh: string;
  refreshExpiresIn: number;
};

export type PostNewUserPayloadType = (
  Pick<NewUserSerializer, 'firstName' | 'lastName' | 'email' | 'headline' | 'location' | 'password' | 'invitationCode' | 'verificationCode' | 'ssoCode'>
);
export type PostNewUserResponseType = (
  Pick<NewUserSerializer, 'email' | 'ssoCode' | 'access' | 'accessExpiresIn' | 'refresh' | 'refreshExpiresIn'>
);

export const apiCreateNewUser = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostNewUserPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.newUser(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
